module.exports = __webpack_public_path__ + "img/1920px-Roundel_of_Japan_(1943).svg.9aeda260.png";